import React from 'react';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: null
    };
  }
  static getDerivedStateFromError(error) {
    //return the new state to trigger a re-render with the fallback UI
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    //log the catched error and save the errorInfo in the state
    this.setState({
      errorInfo
    });
    console.warn(error);
  }
  render() {
    const {
      state: {
        hasError,
        errorInfo
      },
      props: {
        children
      }
    } = this;
    if (hasError && errorInfo) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return children;
  }
}
export default ErrorBoundary;